import axios from 'axios'
import { i18n } from '../../../plugins/i18n'

export const companiesStoreExternalAccount = {
  namespaced: true,
  state: {
    data: null,
    loading: false,
  },
  mutations: {
    prepareApi(state) {
      state.loading = true
    },
    initNewExternalAccount(state, service_type) {
      state.data = {
        attributes: {
          service_type: service_type,
          identifier: null,
          password: null,
        }
      }
    },
    readExternalAccount(state) {
      state.data = null
    },
    readExternalAccountSuccess(state, payload) {
      state.data = payload.data
      state.data.attributes.password = null
      state.loading = false
    },
    apiSuccess(state) {
      state.loading = false
    },
    apiFailure(state) {
      state.loading = false
    },
  },
  actions: {
    readExternalAccount({ commit }, { company_uuid, store_uuid, external_account_id }) {
      commit('prepareApi')
      commit('readExternalAccount')
      return axios
        .get('/api/companies/' + company_uuid + /stores/ + store_uuid + '/external_accounts/' + external_account_id + '.json')
        .then(res => {
          commit('readExternalAccountSuccess', res.data)
        })
        .catch(err => {
          commit('apiFailure')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          console.error(err)
        })
    },
    async createExternalAccount({ commit }, { company_uuid, store_uuid, payload }) {
      commit('prepareApi')
      return axios
        .post('/api/companies/' + company_uuid + /stores/ + store_uuid + '/external_accounts.json', payload)
        .then(() => {
          commit('apiSuccess')
          commit('flash/updateFlash', { type: 'notice', message: i18n.t('messages.created', { value: i18n.t('models.externalAccount.modelName') }) }, { root: true })
          return true
        })
        .catch(err => {
          commit('apiFailure')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          console.error(err)
          return false
        })
    },
    updateExternalAccount({ commit }, { company_uuid, store_uuid, external_account_id, payload }) {
      commit('prepareApi')
      return axios
        .patch('/api/companies/' + company_uuid + /stores/ + store_uuid + '/external_accounts/' + external_account_id + '.json', payload)
        .then(() => {
          commit('apiSuccess')
          commit('flash/updateFlash', { type: 'notice', message: i18n.t('messages.updatedInfo', { value: i18n.t('models.externalAccount.credentials') }) }, { root: true })
          return true
        })
        .catch(err => {
          commit('apiFailure')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          console.error(err)
          return false
        })
    },
    initNewExternalAccount({ commit }, { service_type }) {
      commit('initNewExternalAccount', service_type)
    },
  }
}
